document.addEventListener('DOMContentLoaded', function () {
  const openBtn = document.querySelector('.open-sidebar-button');
  const sidebar = document.getElementById('sidebar-menu');
  const closeBtn = sidebar?.querySelector('.Drawer__Close');

  if (openBtn && sidebar) {
    openBtn.addEventListener('click', () => {
      sidebar.style.display = 'block';
    });
  }

  if (closeBtn && sidebar) {
    closeBtn.addEventListener('click', () => {
      sidebar.style.display = 'none';
    });
  }

  // Abrir/fechar subcategorias
  sidebar.querySelectorAll('.Collapsible__Button[aria-expanded]').forEach(button => {
    button.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));

      const icon = this.querySelector('.Collapsible__Plus');
      if (icon) icon.classList.toggle('is-open');

      const inner = this.nextElementSibling;
      if (inner) {
        inner.style.display = expanded ? 'none' : 'block';
      }
    });
  });

  // Fechar menu e redirecionar
  sidebar.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault(); // impede o clique imediato
      const href = link.getAttribute('href');

      sidebar.style.display = 'none';

      // redirecionar após pequeno delay
      setTimeout(() => {
        window.location.href = href;
      }, 150);
    });
  });
});

